export default __webpack_public_path__ + "static/media/icon-page-error.9e1901df.svg";